var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pagingList.length > 1)?_c('div',{staticClass:"paging-section cl"},_vm._l((_vm.pagingList),function(item){return _c('div',{key:item.title,staticClass:"paging-item fl",class:{active: _vm.page === item.page},on:{"click":function($event){return _vm.toPage(item)}}},[_vm._v(_vm._s(item.title)+"\n    ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }